<template>
  <div>
    <el-form ref="fileImgForm" style="background-color: white;" :model="value" label-width="120px" label-suffix=":">
      <el-row  type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="播放器形式" prop="playerWay">
            <el-select
              v-model="value.playerWay" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="单独页面" value="1"></el-option>
              <el-option label="浮窗" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item  label="是否自动播放" prop="ifAutoPlay">
            <el-select
              v-model="value.ifAutoPlay" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item  label="是否拖动进度条" prop="ifDragPlay">
            <el-select
              v-model="value.ifDragPlay" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item  label="默认图片" prop="defaultImg">
            <el-upload
              :with-credentials="true"
              :action="'/'+GLOBAL.projectName+'/servlet/OmFileUploadServlet'"
              :on-success="(response, file, fileList)=> successFile(response, file, fileList,-1)"
              :on-remove="(file, fileList)=> removeFile(file, fileList,-1)"
              :on-exceed="(files, fileList)=> exceedFile(files, fileList,0)"
              list-type="picture-card"
              :limit="1"
              :file-list="value.defaultImg"
            >
              <el-button slot="trigger" size="small" type="primary"
              >点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                  只能上传图片(jpg/png)
              </div>
            </el-upload>
            <el-button type="primary" size="small" icon="el-icon-plus" circle
              @click="clickAddTimeImg()"
            >
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
          v-for="(imgOne,imgIndex) in value.imgArr" :key="'img_'+imgIndex"
        >
          <el-form-item  :label="'背景图片'+imgIndex" >
            <el-upload
              :with-credentials="true"
              :action="'/'+GLOBAL.projectName+'/servlet/OmFileUploadServlet'"
              :on-success="(response, file, fileList)=> successFile(response, file, fileList,imgIndex)"
              :on-remove="(file, fileList)=> removeFile(file, fileList,imgIndex)"
              :on-exceed="(files, fileList)=> exceedFile(files, fileList,0)"
              list-type="picture-card"
              :limit="1"
              :file-list="imgOne.defaultImg"
            >
              <el-button slot="trigger" size="small" type="primary"
              >点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                  只能上传图片(jpg/png)
              </div>
            </el-upload>
            <el-input placeholder="格式为:01:00-02:00 1分钟到2分钟时显示" v-model="imgOne.showTime">
              <template slot="prepend">显示时长:</template>
            </el-input>
            <el-button type="danger" size="small"
              @click="clickDeleteImg(imgIndex)"
              icon="el-icon-delete"
              circle
            >
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'QuestionFileImgSet',
  props: {
    showType: {
      type:Number,
      default:0
    },
    value: {
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  components: {
  },
  methods: {
    /**
     * 点击添加 根据进度时间的背景图片
     */
    clickAddTimeImg:function(){
      console.log("this.value:",this.value);
      if(!this.value.imgArr) {
        //this.value.imgArr = [];
        this.$set(this.value, "imgArr", []);
      }
      this.value.imgArr.push({});
    },
    /**
     * 删除背景图片
     */
    clickDeleteImg:function(imgIndex){
      this.value.imgArr.splice(imgIndex,1);
    },
     /**
     * 文件上传成功时的处理函数
     */
    successFile:function(response, file, fileList, index){
      var that = this;
      var arr = response.split(":");
      var downAddress = arr[0];
      var fileId = arr[1];
      file.fileId = fileId;
      file.downAddress = downAddress;
      var toHtId = "";
      fileList.forEach(element => {
          if(element.status == "success") {
              if(toHtId!="") {
                  toHtId+=","
              }
              toHtId+=element.fileId;
          }
          var name = element.name;
          element.fileType = that.getFileTypeByName(name);
      });
      file.url = that.GLOBAL.getFileServeUrl() + downAddress;
      if(index == -1) {
        this.value.defaultImg = fileList;
      } else if(index >= 0) {
        this.value.imgArr[index].defaultImg = fileList;
      }
      console.log("this.value==============",this.value);
    },
    /**
     * 文件删除时的处理函数
     */
    removeFile:function(file, fileList,index){
      var that = this;
      var toHtId = "";
      fileList.forEach(element => {
          if(element.status == "success") {
              if(toHtId!="") {
                  toHtId+=","
              }
              toHtId+=element.fileId;
          }
          var name = element.name;
          element.fileType = that.getFileTypeByName(name);
      });
      if(index == -1) {
        this.value.defaultImg = fileList;
      } else if(index >= 0) {
        this.value.imgArr[index].defaultImg = fileList;
      }
      console.log("this.value==============",this.value);
    },
    /**
     * 文件上传个数超出时进行提醒
     */
    exceedFile:function(files, fileList) {
      this.$message({
          message: '最大文件上传个数为:'+5+",不可超出!",
          type: 'warning'
      });
    },
    /**
     * 根据文件名称获取文件类型
     */
    getFileTypeByName(name) {
      var fileType = 'image';
      if(name.indexOf(".jpg") > 0 || name.indexOf(".png") > 0) {
        fileType = "image";
      } else if(name.indexOf(".mp4") > 0 || name.indexOf(".m3u8") > 0 || name.indexOf(".flv") > 0) {
        fileType = "video";
      } else if(name.indexOf(".mp3") > 0) {
        fileType = "audio";
      }
      return fileType;
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
